import React,{useState} from 'react';
import { Modal } from 'antd';


const UnlistModal = () => {
    // 检查当前日期是否大于或等于 2026年3月12日 00:00:00 UTC
    const shouldShow = () => {
        const now = new Date();
        const targetDate = new Date('2026-03-20T00:00:00Z'); // Z 表示 UTC 时区
        return now >= targetDate;
    };
    
    const [isOpen, setIsOpen] = useState(shouldShow());
    return (
        <Modal open={isOpen} onCancel={() => setIsOpen(false)} footer={null} width={window.innerWidth > 768 ? "60vw" : "90vw"}
        bodyStyle={{padding: 0}} style={{borderRadius: '35px',overflow: 'hidden',padding: 0,height: 'auto'}}>
            <img src={require('../../assets/img/Edd.png')} alt="unlist-modal" />
        </Modal>
    )
}

export default UnlistModal;